"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "asOfDate": "2022-03-29T00:00:00",
    "data": [
        {
            "assetClassKey": "ac_a3feff965110450db92d87bde98e12dc",
            "name": "",
            "value": 215744.54,
            "percentageOfPortfolio": 0.075337
        },
        {
            "assetClassKey": "ac_6531a08c235947679b810ce843b3ed29",
            "name": "Australian Cash",
            "value": 1108100.44,
            "percentageOfPortfolio": 0.386945
        },
        {
            "assetClassKey": "ac_f9b759f1c5f1462797aff3db83fbd584",
            "name": "Australian Fixed Income",
            "value": 353521.78,
            "percentageOfPortfolio": 0.123449
        },
        {
            "assetClassKey": "ac_110b35303e184b808b8342c8d0d288b9",
            "name": "Australian Shares",
            "value": 1186348.58,
            "percentageOfPortfolio": 0.414269
        }
    ]
};
